var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Row, Col } from "@riseart/antd-provider";
import { Heading, Paragraph } from "@riseart/common";
import { textColumnsCls, textColumnsSectionCls, textColumnsTitleCls } from "./TextColumns.less";
function TextColumns(_ref) {
  var _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? [] : _ref$columns, _ref$headingTag = _ref.headingTag, headingTag = _ref$headingTag === void 0 ? "h3" : _ref$headingTag;
  return /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    justify: "space-between",
    className: textColumnsCls
  }, columns.map(function(_ref2) {
    var column = _ref2.column, sections = _ref2.sections;
    return /* @__PURE__ */ React.createElement(Col, {
      key: column,
      md: 24,
      lg: 11
    }, sections.map(function(_ref3) {
      var title = _ref3.title, content = _ref3.content;
      return /* @__PURE__ */ React.createElement("div", {
        key: title,
        className: textColumnsSectionCls
      }, /* @__PURE__ */ React.createElement(Heading, {
        tag: headingTag,
        level: "4",
        className: textColumnsTitleCls
      }, title), content.map(function(p, pIdx) {
        return /* @__PURE__ */ React.createElement(Paragraph, {
          key: pIdx
        }, p);
      }));
    }));
  }));
}
__name(TextColumns, "TextColumns");
export {
  TextColumns
};
